module.exports = __webpack_public_path__ + "img/uploadfiles.401f7eff.png";